import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageClick = (page: number) => {
    onPageChange(page);
  };

  const handlePrevClick = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex flex-wrap justify-center items-center gap-2 mt-8">
      <button
        type="button"
        className="min-h-11 md:min-h-0 px-4 py-2 rounded-full border border-line text-sm font-medium text-fg-muted hover:border-line-strong hover:text-fg disabled:opacity-40 disabled:hover:border-line pointer-events-auto z-[9999] transition-colors"
        onClick={handlePrevClick}
        disabled={currentPage === 1}
      >
        Précédent
      </button>
      
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <button
          key={page}
          type="button"
          className={`min-w-11 h-11 md:min-w-9 md:h-9 px-3 rounded-full price text-sm pointer-events-auto z-[9999] transition-colors ${
            page === currentPage
              ? 'bg-accent-strong text-white'
              : 'border border-line text-fg-muted hover:border-line-strong hover:text-fg'
          }`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ))}
      
      <button
        type="button"
        className="min-h-11 md:min-h-0 px-4 py-2 rounded-full border border-line text-sm font-medium text-fg-muted hover:border-line-strong hover:text-fg disabled:opacity-40 disabled:hover:border-line pointer-events-auto z-[9999] transition-colors"
        onClick={handleNextClick}
        disabled={currentPage === totalPages || totalPages === 0}
      >
        Suivant
      </button>
    </div>
  );
};

export default Pagination; 